import {
  CaracteristicasState,
  MetadataState,
  caracteristicasInitialState,
  metadataInitialState,
  CaracteristicasAction,
} from 'store/modules/cdca/caracteristicas';
import { CriteriosRemuneracaoAction, criteriosRemuneracaoInitialState } from 'store/modules/cdca/criteriosRemuneracao';
import { EventosAction, eventosInitialState } from 'store/modules/cdca/eventos';
import { UploadDocumentosAction, uploadDocumentosInitialState } from 'store/modules/cdca/uploadDocumentos';
import { EmissorAction, State as EmissorState, initialState as emissorInitialState } from 'store/modules/cdca/emissor';
import { CriteriosRemuneracao, Amortizacao, UploadDocumentos, TipoRegistroInstrumentoFinanceiro, EventosFinanceiros as EventosState } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { Attachment } from 'components/uploadDocs';
import { AditamentoAction } from './aditamento';

interface State {
  caracteristicas: CaracteristicasState;
  metadata: MetadataState;
  criteriosRemuneracao: CriteriosRemuneracao;
  emissor: EmissorState;
  eventos: EventosState;
  uploadDocumentos: UploadDocumentos;
  highlightErrors: boolean;
  typeOfRegister: TipoRegistroInstrumentoFinanceiro;
  uploadDocumentoAditamento: Attachment[];
  dataAditamento: string | undefined;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('cdca/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('cdca/HIGHLIGHT_ERRORS', payload);
};

export function cdcaReducer(
  state: State = {
    caracteristicas: caracteristicasInitialState,
    metadata: metadataInitialState,
    criteriosRemuneracao: criteriosRemuneracaoInitialState,
    emissor: emissorInitialState,
    eventos: eventosInitialState,
    uploadDocumentos: uploadDocumentosInitialState,
    highlightErrors: false,
    typeOfRegister: TipoRegistroInstrumentoFinanceiro.Cadastro,
    uploadDocumentoAditamento: [],
    dataAditamento: undefined,
  },
  action:
    | CaracteristicasAction
    | CriteriosRemuneracaoAction
    | EmissorAction
    | EventosAction
    | UploadDocumentosAction
    | ReturnType<typeof highlightErrors>
    | ReturnType<typeof typeOfRegister>
    | AditamentoAction
): State {
  switch (action.type) {
    //Características
    case 'cdca/metadata/UPDATEFIELD':
      return { ...state, metadata: { ...state.metadata, [action.payload.name]: action.payload.value } };
    case 'cdca/caracteristicas/UPDATEFIELD':
      return { ...state, caracteristicas: { ...state.caracteristicas, [action.payload.name]: action.payload.value } };
    case 'cdca/caracteristicas/RESET':
      return { ...state, caracteristicas: { ...caracteristicasInitialState } };
    case 'cdca/caracteristicas/UPDATE':
      return { ...state, caracteristicas: action.payload };
    //Critério de Remuneração
    case 'cdca/criteriosRemuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: { ...state.criteriosRemuneracao, [action.payload.name]: action.payload.value },
      };
    case 'cdca/criteriosRemuneracao/remuneracao/UPDATE':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: action.payload,
        },
      };
    case 'cdca/criteriosRemuneracao/remuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: { ...state.criteriosRemuneracao.remuneracao, [action.payload.name]: action.payload.value },
        },
      };
    case 'cdca/criteriosRemuneracao/RESET':
      return { ...state, criteriosRemuneracao: criteriosRemuneracaoInitialState };
    case 'cdca/criteriosRemuneracao/UPDATE':
      return { ...state, criteriosRemuneracao: action.payload };
    //Custo de Emissão
    case 'cdca/criteriosRemuneracao/custoEmissao/UPDATEFIELD':
      return { 
        ...state, 
        criteriosRemuneracao: { 
          ...state.criteriosRemuneracao, 
          custoEmissao: {
            ...state.criteriosRemuneracao.custoEmissao, [action.payload.name]: action.payload.value },
        }
      };
    //Emissor
    case 'cdca/emissor/UPDATE_ID':
      return { ...state, emissor: { ...state.emissor, id: action.payload } };
    case 'cdca/emissor/UPDATE_CODIGO':
      return { ...state, emissor: { ...state.emissor, codigoExterno: action.payload } };
    case 'cdca/emissor/RESET':
      return { ...state, emissor: { ...emissorInitialState } };
    //Eventos Financeiros
    case 'cdca/eventos/UPDATE':
      return { ...state, eventos: action.payload };
    case 'cdca/eventos/UPDATEFIELD':
      return { ...state, eventos: { ...state.eventos, [action.payload.name]: action.payload.value } };
    case 'cdca/eventos/RESET':
      return { ...state, eventos: eventosInitialState };
    case 'cdca/eventos/datasPagamentoJuros/UPDATE':
      return {
        ...state,
        eventos: { ...state.eventos, datasPagamentoJuros: action.payload.map((dateViewModel) => dateViewModel.date) },
      };
    case 'cdca/eventos/datasIncorporacaoJuros/UPDATE':
      return {
        ...state,
        eventos: {
          ...state.eventos,
          datasIncorporacaoJuros: action.payload.map((dateViewModel) => dateViewModel.date),
        },
      };
    case 'cdca/eventos/amortizacoes/UPDATE':
      const amortizacoes: Amortizacao[] = action.payload.map((amortizacao) => ({
        percentualAmortizacao: amortizacao.percentualAmortizacao,
        dataAmortizacao: amortizacao.dataAmortizacao,
      }));
      return {
        ...state,
        eventos: { ...state.eventos, amortizacoes },
      };
    //Documentos
    case 'cdca/uploadDocumentos/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documents: action.payload },
      };
    case 'cdca/uploadDocumentos/documentsToDelete/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documentsToDelete: action.payload },
      };
    case 'cdca/uploadDocumentos/RESET':
      return { ...state, uploadDocumentos: uploadDocumentosInitialState };
    //Erros
    case 'cdca/HIGHLIGHT_ERRORS':
      return { ...state, highlightErrors: action.payload };
    //Type of Register
    case 'cdca/TYPE_OF_REGISTER':
      return { ...state, typeOfRegister: action.payload };
    //Aditamento
    case 'cdca/UPLOAD_DOCUMENTO_ADITAMENTO':
      return { ...state, uploadDocumentoAditamento: action.payload };
    case 'cdca/UPLOAD_DOCUMENTO_ADITAMENTO/RESET':
      return { ...state, uploadDocumentoAditamento: [] };
    case 'cdca/DATA_ADITAMENTO':
      return { ...state, dataAditamento: action.payload };
    case 'cdca/DATA_ADITAMENTO/RESET':
      return { ...state, dataAditamento: undefined };
    default:
      return state;
  }
}

export default cdcaReducer;
